import styled from 'styled-components';

import { StyledFlex, Text } from '@dreryk/react-components';

export const StyledOverlapDot = styled(StyledFlex)`
   position: relative;
`;
StyledOverlapDot.displayName = 'StyledOverlapDot';

export const StyledCounter = styled(Text)`
   position: absolute;
   font-size: 8px;
   color: ${(props) => props.theme.white};
   margin-top: 1px;
   white-space: nowrap;
`;

StyledCounter.displayName = 'StyledCounter';
